import React from "react";

import * as S from "./styles";

export const Slide10: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Credit>Vestido, Neriage, R$ 3.400.</S.Credit>
        <S.Content>
          <S.Photo />
        </S.Content>
      </S.Wrapper>
    </S.Container>
  );
};
